module.exports = __webpack_public_path__ + "static/media/flow2small.23b0cd7b.mp4";